export function NotFoundException(message) {
  this.message = message;
  this.type = 'not_found';
}

export function ParamsMissingException(message) {
  this.message = message;
  this.type = 'params_catalog_missing';
}
